export class URLParamsModel {

  constructor(_key: string) {
    this.key = _key;
    this.value = null;
  }
  key: string;
  value: string;
}



// WEBPACK FOOTER //
// ./src/app/core/models/url.params.model.ts